import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom"
//Redux
import { useDispatch, useSelector } from "react-redux";
import { listProducts } from "../../redux/product/productActions";
//MUI
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Pagination from "@material-ui/lab/Pagination";
import Slider from "@material-ui/core/Slider";
import Hidden from "@material-ui/core/Hidden";
//Icons
import SearchIcon from "@material-ui/icons/Search";
//My Components
import ExtraWideLayout from "../../layouts/ExtraWideLayout";
import ProductBox from "../../components/Entities/Product/ProductBox";
import ProductLoader from "../../components/Entities/Product/ProductLoader";
import Meta from "../../components/Global/Meta/Index";
import AlertMessage from "../../components/Global/Message/Alert";
import SubCategoriesCarousel from "../../components/Entities/SubCat/CarouselSlick";
import * as TextLoader from "../../components/StaticTexts/Index";
import { Formik } from "formik";
import {
    isMobile
} from "react-device-detect";

const numberLoader = [1, 2, 3, 4, 5, 6, 7, 8]

const useStyles = makeStyles((theme) => ({
    base: {
        flexGrow: 1,
        marginTop: "24px",
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    grayBox: {
        backgroundColor: "#f2f2f2",
    },
    paper: {
        padding: theme.spacing(2),
        backgroundColor: "transparent !important",
        border: "none !important",
        boxShadow: "none",
        padding: "10px auto",
    },
    btn: {
        backgroundColor: "#950000",
        fontWeight: "700",
        "&:hover": {
            backgroundColor: "#950000",
        },
        color: "#fff",
        width: "150px",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    breadcrumbs: {
        padding: "0",
        margin: "10px 0 0 0",
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        width: "39%",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        border: "1px #3d3d3d solid",
        height: "40px",
        marginTop: "0px",
        paddingRight: "10px !important",
        textAlign: "right !important",
    },
    box: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(16),
            height: theme.spacing(16),
        },
    },
    slider: {
        width: "100%",
        marginTop: "25px",
        marginBottom: "25px",
    },
    formControl: {
        width: "100%",
    },
}));

function slideValuetext(value) {
    return `${value}تومان`;
}

const numbers = [1, 2, 3, 4, 5, 6]

const ProductList = ({ history, match, lang }) => {
    //GLOBAL
    const [staticText, setStaticText] = useState({});
    const classes = useStyles();

    //Page Level
    const searchURL = history.location.search
    // let pageNumber = match.params.pageNumber || 1
    // let keyword = new URLSearchParams(searchURL).get("keyword") || ""
    // let mainCategoryId = match.params.mainCategoryId ? match.params.mainCategoryId : 0
    // let subCategoryId = match.params.subCategoryId ? match.params.subCategoryId : 0
    // let secondaryCategoryId = match.params.secondarySubCategoryId ? match.params.secondarySubCategoryId : 0
    // let q_descendingSort = new URLSearchParams(searchURL).get("descendingSort") || false;
    // let q_priceMin = new URLSearchParams(searchURL).get("priceMin") || 0;
    // let q_priceMax = new URLSearchParams(searchURL).get("priceMax") || 0;

    const [pageLoading, setPageLoading] = useState(true);
    const [reqPageNumber, setReqPageNumber] = useState(match.params.pageNumber || 1);
    const [reqKeyword, setReqKeyword] = useState(new URLSearchParams(searchURL).get("keyword") || "");
    const [reqMainCategoryId, setReqMainCategoryId] = useState(match.params.mainCategoryId ? match.params.mainCategoryId : 0);
    const [reqSubCategoryId, setReqSubCategoryId] = useState(match.params.subCategoryId ? match.params.subCategoryId : 0);
    const [reqSecondaryCategoryId, setReqSecondaryCategoryId] = useState(
        match.params.secondarySubCategoryId ? match.params.secondarySubCategoryId : 0
    );
    const [reqDescendingSort, setReqDescendingSort] = useState(new URLSearchParams(searchURL).get("descendingSort") || false);
    const [reqPriceMin, setReqPriceMin] = useState(new URLSearchParams(searchURL).get("priceMin") || 0);
    const [reqPriceMax, setReqPriceMax] = useState(new URLSearchParams(searchURL).get("priceMax") || 0);
    const [reqPriceRange, setReqPriceRange] = useState([0, 30000]);
    const [breadcrumbsItems, setBreadcrumbsItems] = useState([]);
    const [addressChanged, setAddressChanged] = useState(false);
    //Redux init dispatch
    const dispatch = useDispatch();
    const pageData = useSelector((state) => state.productList);
    const {
        loading,
        error,
        mainCategories,
        subCategories,
        secondarySubCategories,
        outOfStock,
        productList,
        totalPages,
        priceMin,
        priceMax,
    } = pageData;

    //Page Level Functions
    const handleSliderChange = (event, newValue) => {
        setReqPriceRange(newValue);
    };

    const handleChangePage = (event, value) => {
        setReqPageNumber(value);
        var loc = history.location.pathname;
        //console.log(loc)
        var baseURL = `/products/page/${value}`;
        var quqeryStrings = "";
        if (reqKeyword !== "") {
            quqeryStrings = "?keyword=" + reqKeyword;
        } else {
            if (loc.includes("/page/")) {
                var res = loc.split("/");
                if (res.length >= 4 && !isNaN(res[4])) {
                    baseURL += `/${res[4]}`;
                }

                if (res.length >= 5 && !isNaN(res[5])) {
                    baseURL += `/${res[5]}`;
                }

                if (res.length >= 6 && !isNaN(res[6])) {
                    baseURL += `/${res[6]}`;
                }
            }
        }
        if (Boolean(reqDescendingSort)) {
            quqeryStrings += "&descendingSort=" + reqDescendingSort;
        }
        if (Number(reqPriceMin) !== 0) {
            if (quqeryStrings !== "") quqeryStrings += "&priceMin=" + reqPriceMin;
            else quqeryStrings += "?priceMin=" + reqPriceMin;
        }
        if (Number(reqPriceMax) !== 0) {
            if (quqeryStrings !== "") quqeryStrings += "&priceMax=" + reqPriceMax;
            else quqeryStrings += "?priceMax=" + reqPriceMax;
        }
        history.push({
            pathname: baseURL,
            search: `${quqeryStrings}`,
        });
        setPageLoading(true);
        window.scrollTo(0, 0);
    };

    const changeMainCategory = (event) => {
        if (event.target.value !== "0") {
            setReqMainCategoryId(event.target.value);
            history.push(`/products/page/1/${event.target.value}`);
            setPageLoading(true);
        }
    };

    const handleChangeSecondaryChange = (event) => {
        setReqSecondaryCategoryId(event.target.value);
        history.push(
            `/products/page/1/${reqMainCategoryId}/${reqSubCategoryId}/${event.target.value}`
        );
        setPageLoading(true);
    };

    const handleChangeSort = (event) => {
        setReqDescendingSort(event.target.value);
        if (reqKeyword !== "") {
            history.push({
                pathname: history.location.pathname,
                search: `?keyword=${reqKeyword}&descendingSort=${event.target.value}`,
            });
        } else {
            history.push({
                pathname: history.location.pathname,
                search: `?descendingSort=${event.target.value}`,
            });
        }
        setPageLoading(true);
        // if (history.location.pathname.includes('?'))
        //     history.push(`${history.location.pathname}&descendingSort=${event.target.value}`)
        // else
        //     history.push(`${history.location.pathname}?&descendingSort=${event.target.value}`)
    };

    React.useEffect(() => {
        if (typeof mainCategories !== "undefined") {
            if (mainCategories.length > 0 && (Number(reqMainCategoryId) === 0)) {
                setReqMainCategoryId(mainCategories[0].id);
            }
        }
    }, [dispatch, mainCategories]);

    useEffect(() => {
        if (typeof subCategories !== "undefined") {
            if (subCategories.length > 0 && (Number(reqSubCategoryId) === 0)) {
                setReqSubCategoryId(subCategories[0].id);
            }
        }
    }, [dispatch, subCategories]);

    React.useEffect(() => {
        if (typeof secondarySubCategories !== "undefined") {
            if (secondarySubCategories.length > 0) {
                if (Number(reqSecondaryCategoryId) === 0)
                    setReqSecondaryCategoryId(secondarySubCategories[0].id);
            }
        }
    }, [dispatch, secondarySubCategories]);

    useEffect(() => {

        if (lang === "fa") {
            setBreadcrumbsItems([
                {
                    title: "صفحه اصلی",
                    to: "/",
                },
                {
                    title: "لیست محصولات",
                    to: "/products",
                },
            ]);
        } else {
            setBreadcrumbsItems([
                {
                    title: "الصفحة الأصلية",
                    to: "/",
                },
                {
                    title: "منتجات",
                    to: "/products",
                },
            ]);
        }
        setStaticText(TextLoader.staticTextLoader("productList", lang));
        dispatch(
            listProducts(
                lang,
                reqPageNumber,
                reqKeyword,
                reqMainCategoryId,
                reqSubCategoryId,
                reqSecondaryCategoryId,
                reqPriceMin,
                reqPriceMax,
                reqDescendingSort
            )
        ).then(() => {
            setPageLoading(false);
        });

        return history.listen((location) => {
            var loc = location.pathname;
            const searchURL1 = history.location.search
            var doAction = false
            var dontCheck = false
            var dontAddOtherOrders = false
            let pageNumber = 1
            let keyword = new URLSearchParams(searchURL1).get("keyword") || ""
            let mainCategoryId = 0
            let subCategoryId = 0
            let secondaryCategoryId = 0
            let q_priceMin = 0
            let q_priceMax = 0
            let q_descendingSort = false
            if (loc === "/products" && keyword === '') {
                setReqKeyword(keyword)
                setReqMainCategoryId(0)
                setReqSubCategoryId(0)
                setReqSecondaryCategoryId(0)
                doAction = true
                dontAddOtherOrders = true
            } else {
                if (keyword !== '') {
                    setReqKeyword(keyword)
                    setReqMainCategoryId(0)
                    setReqSubCategoryId(0)
                    setReqSecondaryCategoryId(0)
                    doAction = true
                    dontAddOtherOrders = true
                }
                else if (loc.includes("/products/page/")) {
                    setReqKeyword('')
                    doAction = true
                    var res = loc.split("/");
                    if (res.length >= 3 && !isNaN(res[3])) {
                        pageNumber = res[3];
                        setReqPageNumber(res[3]);
                    }
                    if (res.length === 5 && !isNaN(res[4])) {
                        mainCategoryId = res[4];
                        setReqMainCategoryId(res[4])
                        setReqSubCategoryId(0)
                        setReqSecondaryCategoryId(0)
                        dontCheck = true
                    }
                    else if (res.length > 5 && !isNaN(res[4])) {
                        mainCategoryId = res[4];
                        setReqMainCategoryId(res[4]);
                    }

                    if (!dontCheck) {

                        if (res.length === 6 && !isNaN(res[5])) {
                            setReqSubCategoryId(res[5])
                            setReqSecondaryCategoryId(0)
                            subCategoryId = res[5]
                            secondaryCategoryId = 0
                            dontCheck = true
                        }
                        else if (res.length > 6 && !isNaN(res[5])) {
                            subCategoryId = res[5]
                            setReqSubCategoryId(res[5])
                        }

                        if (!dontCheck) {
                            if (res.length >= 7 && !isNaN(res[6])) {

                                secondaryCategoryId = res[6];
                                setReqSecondaryCategoryId(res[6]);
                            }
                        }

                    }
                }
            }

            if (doAction) {

                if (!dontAddOtherOrders) {
                    const search = location.search
                    q_descendingSort = new URLSearchParams(search).get("descendingSort") || false;
                    setReqDescendingSort(q_descendingSort);
                    q_priceMin = new URLSearchParams(search).get("priceMin") || 0;
                    setReqPriceMin(q_priceMin);
                    q_priceMax = new URLSearchParams(search).get("priceMax") || 0;
                    setReqPriceMax(q_priceMax);
                }
                else {
                    setReqDescendingSort(false)
                    setReqPriceMin(0)
                    setReqPriceMax(0)
                }

                dispatch(
                    listProducts(
                        lang,
                        pageNumber,
                        keyword,
                        mainCategoryId,
                        subCategoryId,
                        secondaryCategoryId,
                        q_priceMin,
                        q_priceMax,
                        q_descendingSort
                    )
                ).then(() => {
                    setPageLoading(false);
                });
            }
        });

    }, [dispatch, history]);

    return (
        <>
            <Meta />
            <ExtraWideLayout lang={lang} showBreadcrumbs={false}>

                <Grid item md={8} xs={12}>
                    <Paper elevation={0}>
                        <Box
                            elevation={0}
                            boxShadow={0}
                            p={1}
                            m={1}
                            className="breadcrumbs-container">
                            <Breadcrumbs
                                className={classes.breadcrumbs + " breadcrumbs"}
                                separator="›"
                                aria-label="breadcrumb"
                            >
                                {breadcrumbsItems.map((item, i) =>
                                    i + 1 !== breadcrumbsItems.length ? (
                                        <RouterLink to={item.to} color="inherit">
                                            {item.title}
                                        </RouterLink>
                                    ) : (
                                        <Typography color="textPrimary">{item.title}</Typography>
                                    )
                                )}
                            </Breadcrumbs>
                        </Box>
                    </Paper>
                </Grid>

                <Hidden only={["md", "lg", "sm"]}>
                    <Grid item xs={12}>
                        <Paper elevation={0}>
                            <Box elevation={0} boxShadow={0} p={1} m={1}>
                                <FormControl className={classes.formControl}>
                                    <Select
                                        value={reqMainCategoryId}
                                        onChange={changeMainCategory}
                                        style={{ width: "100%" }}
                                        className={classes.selectEmpty}
                                        inputProps={{
                                            name: "mainCat",
                                            id: "mainCat-simple",
                                        }}>
                                        <MenuItem value="0">
                                            <em> {staticText.mainCatTitle} </em>
                                        </MenuItem>
                                        {mainCategories.map((item) => {
                                            return <MenuItem value={item.id}>{item.title}</MenuItem>;
                                        })}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Paper>
                    </Grid>
                </Hidden>

                <Grid item md={4} xs={12} className="text-left productListSearch">
                    <Paper elevation={0}>
                        <Box elevation={0} boxShadow={0} p={1} m={1}>
                            <Formik
                                initialValues={{ keyword: reqKeyword }}
                                validate={(values) => {
                                    const errors = {};
                                    if (!values.keyword) {
                                        errors.keyword = "Required";
                                    }
                                    return errors;
                                }}
                                onSubmit={(values, { setSubmitting }) => {
                                    setTimeout(() => {
                                        if (values.keyword.trim() !== "") {
                                            history.push({
                                                pathname: "/products/",
                                                search: `&keyword=${values.keyword.trim()}`,
                                            });
                                            setPageLoading(true);
                                        }
                                        setSubmitting(false);
                                    }, 400);
                                }}
                            >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                }) => (
                                    <form
                                        onSubmit={handleSubmit}
                                        className="search-form productSearchForm"
                                        style={{ margin: "0px" }}
                                    >
                                        <input
                                            type="text"
                                            name="keyword"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder={staticText.searchText}
                                            value={values.keyword}
                                            className="productListSearchInput"
                                        />
                                        <button
                                            type="submit"
                                            className="btnGreen"
                                            disabled={isSubmitting}
                                        >
                                            <SearchIcon />
                                        </button>
                                    </form>
                                )}
                            </Formik>
                        </Box>
                    </Paper>
                </Grid>

                <Grid item md={12} xs={12}>
                    <Paper elevation={0}>
                        <Box elevation={0} className={classes.subCategoriesCarousel} boxShadow={0} p={2} m={1} mb={3}>
                            <SubCategoriesCarousel
                                loading={pageLoading}
                                subCategories={subCategories}
                                reqPageNumber={reqPageNumber}
                                isMobile={isMobile}
                                reqMainCategoryId={reqMainCategoryId}
                                reqSubCategoryId={reqSubCategoryId}
                            />
                        </Box>
                    </Paper>
                </Grid>

                <Hidden only={["xs"]}>
                    <Grid item md={2} xs={12}>
                        <Paper elevation={0}>
                            <Box elevation={1} boxShadow={0} p={1} m={1}>
                                <div className="gray-box-with-title">
                                    <div className="title">{staticText.mainCatTitle}</div>
                                    <div className="content">
                                        <form>
                                            {mainCategories.length === 0 && (
                                                numbers.map(() => (<>
                                                    <Skeleton animation="wave" height="30px" width="60%" />
                                                    <br />
                                                </>
                                                ))
                                            )
                                            }
                                            {!loading && !error && mainCategories.length > 0 && (
                                                <>
                                                    <RadioGroup
                                                        aria-label="mainCat"
                                                        name="mainCat"
                                                        value={reqMainCategoryId.toString()}
                                                        onChange={changeMainCategory}
                                                    >
                                                        {mainCategories.map((Category) => (
                                                            <FormControlLabel
                                                                value={Category.id.toString()}
                                                                control={<Radio />}
                                                                label={Category.title}
                                                            />
                                                        ))}
                                                    </RadioGroup>
                                                </>
                                            )}
                                        </form>
                                    </div>
                                </div>
                                <div
                                    className="gray-box-with-title"
                                    style={{ marginTop: "20px", display: "none" }}
                                >
                                    <div className="title">{staticText.rangeSelectTitle}</div>
                                    <div className="content">
                                        <Slider
                                            defaultValue={0}
                                            className={classes.slider}
                                            min={priceMin}
                                            max={priceMax}
                                            onChange={handleSliderChange}
                                            valueLabelDisplay="on"
                                            aria-labelledby="range-slider"
                                            getAriaValueText={slideValuetext}
                                        />
                                    </div>
                                </div>
                            </Box>
                        </Paper>
                    </Grid>
                </Hidden>

                <Grid item md={10} xs={12} className="text-left">
                    <Paper elevation={0}>
                        <Box
                            boxShadow={1}
                            p={1}
                            m={1}
                            borderColor="#f2f2f2"
                            border={1}
                            borderRadius={16}
                            className={classes.grayBox + " articelsList"}>
                            <Grid container>
                                <Hidden only={["xs"]}>
                                    <Grid item md={6} xs={12}>
                                        <Box
                                            boxShadow={1}
                                            p={1}
                                            m={1}
                                            borderColor="#fff"
                                            border={1}
                                            borderRadius={16}
                                            className={classes.whiteBox}
                                        >
                                            <form
                                                className={classes.root}
                                                autoComplete="off"
                                                style={{ width: "100%" }}
                                            >
                                                <Grid container spacing={1}>
                                                    <Grid item xs={6}>
                                                        <FormControl className={classes.formControl}>
                                                            <Select
                                                                value={reqSecondaryCategoryId}
                                                                onChange={handleChangeSecondaryChange}
                                                                style={{ width: "100%" }}
                                                                className={classes.selectEmpty}
                                                                inputProps={{
                                                                    name: "age",
                                                                    id: "age-simple",
                                                                }}
                                                            >
                                                                <MenuItem value="0">
                                                                    <em>{staticText.subCat}</em>
                                                                </MenuItem>
                                                                {secondarySubCategories.map((item) => {
                                                                    return (
                                                                        <MenuItem value={item.id}>
                                                                            {item.title}
                                                                        </MenuItem>
                                                                    );
                                                                })}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <FormControl className={classes.formControl}>
                                                            <Select
                                                                value={reqDescendingSort}
                                                                onChange={handleChangeSort}
                                                                style={{ width: "100%" }}
                                                                inputProps={{
                                                                    name: "sorting",
                                                                    id: "sorting-select",
                                                                }}
                                                                displayEmpty
                                                                className={classes.selectEmpty}
                                                            >
                                                                <MenuItem value={true}>
                                                                    {staticText.desSort}
                                                                </MenuItem>
                                                                <MenuItem value={false}>
                                                                    {staticText.ascSort}
                                                                </MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Box>
                                    </Grid>
                                    <Grid item md={6} xs={12}></Grid>
                                </Hidden>
                                <Hidden only={["md", "sm", "lg"]}>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl}>
                                            <Select
                                                value={reqSecondaryCategoryId}
                                                onChange={handleChangeSecondaryChange}
                                                style={{ width: "100%" }}
                                                className={classes.selectEmpty}
                                                inputProps={{
                                                    name: "su",
                                                    id: "age-simple",
                                                }}
                                            >
                                                <MenuItem value="0">
                                                    <em>{staticText.subCat}</em>
                                                </MenuItem>
                                                {secondarySubCategories.map((item) => {
                                                    return (
                                                        <MenuItem value={item.id}>
                                                            {item.title}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Hidden>
                                <Grid item md={12} xs={12}>
                                    <Paper elevation={0}>
                                        <Box
                                            boxShadow={0}
                                            border={0}
                                            p={1}
                                            m={0}
                                            borderColor="#f2f2f2"
                                            className={classes.grayBox}
                                        >
                                            <Hidden only={["xs"]}>
                                                <hr />
                                            </Hidden>
                                            <Grid
                                                container
                                                mr={{ md: "40px", xs: "0px" }}
                                                spacing={1}>
                                                {pageLoading &&
                                                    numberLoader.map((product, i) => (
                                                        <Grid item md={3} xs={6} spacing={1}>
                                                            <Paper
                                                                elevation={0}
                                                                className={
                                                                    classes.paperNoBg + " productsList"
                                                                }
                                                            >
                                                                <Box
                                                                    elevation={1}
                                                                    boxShadow={0}
                                                                    border={0}
                                                                    p={{ md: 1, lg: 1, xs: 0 }}
                                                                    m={{ md: 1, lg: 1, xs: 0 }}
                                                                >
                                                                    <ProductLoader lang={lang} />
                                                                </Box>
                                                            </Paper>
                                                        </Grid>
                                                    ))}
                                                {!pageLoading && !error ? (
                                                    <>
                                                        {productList.length > 0 ? (
                                                            <>
                                                                {productList.map((product, i) => (
                                                                    <Grid item md={3} xs={6} spacing={1}>
                                                                        <Paper
                                                                            elevation={0}
                                                                            className={
                                                                                classes.paperNoBg + " productsList product-list-box-container"
                                                                            }
                                                                        >
                                                                            <Box
                                                                                elevation={1}
                                                                                boxShadow={0}
                                                                                border={0}
                                                                                p={{ md: 1, lg: 1, xs: 0 }}
                                                                                m={{ md: 1, lg: 1, xs: 0 }}
                                                                            >
                                                                                <ProductBox
                                                                                    lang={lang}
                                                                                    key={i}
                                                                                    product={product}
                                                                                />
                                                                            </Box>
                                                                        </Paper>
                                                                    </Grid>
                                                                ))}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <AlertMessage variant="info">
                                                                    {staticText.emptyProducts}
                                                                </AlertMessage>
                                                            </>
                                                        )}
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                            </Grid>
                                        </Box>
                                    </Paper>
                                </Grid>
                                {totalPages > 1 && (
                                    <Grid style={{ margin: "0px auto" }}>
                                        <Grid
                                            justify="center"
                                            alignItems="center"
                                            item
                                            md={12}
                                            xs={12}>
                                            <Paper
                                                elevation={0}
                                                style={{ backgroundColor: "transparent" }}>
                                                <Box
                                                    boxShadow={0}
                                                    border={0}
                                                    p={1}
                                                    m={2}
                                                    borderColor="#f2f2f2"
                                                    className={classes.grayBox}>
                                                    <Pagination
                                                        count={Number(totalPages)}
                                                        page={Number(reqPageNumber)}
                                                        variant="outlined"
                                                        shape="rounded"
                                                        onChange={handleChangePage}
                                                    />
                                                </Box>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>

            </ExtraWideLayout>
        </>
    );
};

export default ProductList;
